import * as API from 'common/constant/routes'
import { getJson, postJson, putFile } from 'helper/http'
import toSnakeCase from '@deliverance-ai/map-keys-case/to-snake-case'

export const getInsights = (sort, direction, limit, start) => getJson(API.GET_INSIGHTS, {}, toSnakeCase({ direction, limit, sort, start }))
export const addNewInsight = (insightObject) => postJson(API.ADD_INSIGHT, {}, { ...insightObject })
export const editInsight = (insightObject) => postJson(API.EDIT_INSIGHT, {}, { ...insightObject })
export const uploadFile = (url, file) => putFile(url, file, file.type)
export const searchInsights = (searchTerm, sort, direction, limit, start) => getJson(API.SEARCH_INSIGHTS, {}, toSnakeCase({ direction, limit, searchTerm, sort, start }))
export const downloadInsights = (columns) => postJson(API.DOWNLOAD_INSIGHTS, {}, { columns })
